import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'Src/ng2/shared/services/api-service/api-service';
import { TValidPartnerTypes, IPartner } from 'Src/ng2/shared/typings/interfaces/partner.interface';

@Injectable()
export class PartnerPickerDataService {
  constructor(private apiService: ApiService) {}

  getPartners(type: string): Observable<IPartner[]> {
    const params = { type };
    const projections = ['_id', 'partnerName'];
    return this.apiService.getPartners({ params, projections });
  }

  getPartnerType(url: string): TValidPartnerTypes {
    const matched = url.match(/\/.*-picker/);
    const partnerType = matched && matched[0].split(/\/|-picker/).join('');
    return partnerType as TValidPartnerTypes;
  }
}
